export default [
  {
    path: '/Terms',
    name: 'terms',
    component: () => import('@/pages/supplier/terms/Terms'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/Contact-Rep-Legal',
    name: 'terms-contact-rep-legal',
    component: () => import('@/pages/supplier/terms/ContactRepLegal'),
    meta: {
      layout: 'blank',
    },
  },
];




// WEBPACK FOOTER //
// ./src/router/routes/termsAndConditions.js